// The entry point for Server Actions: the "action door" into the router.
// Server Actions are deliberately not a navigator operation (navigator.ts) —
// the action queue is semantically separate from the router state queue —
// but this module forks the same way: by default it re-exports the
// sequential implementation, and when `experimental.concurrentRouterQueue`
// is enabled, imports of this module resolve to './concurrent-call-server'
// instead at the bundler level (see create-compiler-aliases.ts and
// next_import_map.rs). Both implementations expose exactly this surface.

/**
 * Invoke a Server Action. The returned promise resolves with the action's
 * return value once the response has been processed. Navigation and
 * revalidation side effects of the action are handled by the router; they are
 * not observable through the returned promise.
 */
export { callServer } from './sequential-call-server'
